import { useMutation, useQuery } from "react-query";
import { isEmpty } from "../../lib/helpers/helpers";
import {
	commentOnWeddingPost,
	fetchTimeline,
	fetchWeddingPost,
	getTimelinePostDetails,
	reactToWeddingPost,
} from "../actions/timeline";

export const useTimeline = ({ page }) => {
	return useQuery(["timeline", { page }], () =>
		fetchTimeline({
			page,
		})
	);
};

export const useFetchTimelineDetail = ({
	weddingId,
	postId,
	comments_paginate,
}) => {
	return useQuery(
		["timelineDetail", { weddingId, postId, comments_paginate }],
		() => getTimelinePostDetails({ weddingId, postId, comments_paginate }),
		{
			enabled: !isEmpty(weddingId) && !isEmpty(postId),
		}
	);
};

export const useFetchWeddingPost = ({ weddingId, paginate, all }) => {
	return useQuery(
		["wedding_post", { weddingId, paginate }],
		() => fetchWeddingPost({ weddingId, paginate }),
		{
			enabled: !isEmpty(weddingId) && !all,
		}
	);
};

export const usePostAction = () => {
	return useMutation(reactToWeddingPost);
};

export const useCommentPost = () => {
	return useMutation(commentOnWeddingPost);
};
